import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden xl:flex gap-2 items-center gap-x-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.40002 4.7999L12 4.7999M2.40002 11.9999H12M12 11.9999V14.3999M12 11.9999V9.5999M2.40002 19.1999H7.20002M12 19.1999L21.6 19.1999M16.8 11.9999H21.6M16.8 4.7999L21.6 4.7999M16.8 4.7999V7.1999M16.8 4.7999V2.3999M7.80002 21.5999V16.7999",
    stroke: "black",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = { class: "px-4 py-3" }
const _hoisted_4 = { class: "px-4 py-3" }
const _hoisted_5 = { class: "px-4 py-3" }
const _hoisted_6 = { class: "px-4 py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_StatusFilter = _resolveComponent("StatusFilter")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_AutoComplete, {
        modelValue: _ctx.selectedStoreFilter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStoreFilter) = $event)),
        "return-by": "'Name'",
        items: _ctx.joinedByStoreId,
        "track-by": "Name",
        "filter-by": "Name",
        "show-by": "Name",
        placeholder: "Store",
        "show-close": true,
        onSubmit: _cache[1] || (_cache[1] = (val) => _ctx.findStore()),
        onClose: _cache[2] || (_cache[2] = (val) => _ctx.findStore(null))
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_AutoComplete, {
        modelValue: _ctx.selectedCustomerFilter,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCustomerFilter) = $event)),
        "return-by": "'Name'",
        items: _ctx.joinedByCustomerId,
        "track-by": "Name",
        "filter-by": "Name",
        "show-by": "Name",
        placeholder: "Customer",
        "show-close": true,
        onSubmit: _cache[4] || (_cache[4] = (val) => _ctx.findCustomer()),
        onClose: _cache[5] || (_cache[5] = (val) => _ctx.findCustomer(null))
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_AutoComplete, {
        modelValue: _ctx.selectedDeliveryTypeFilter,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDeliveryTypeFilter) = $event)),
        items: _ctx.joinedByDeliveryType,
        placeholder: "Type",
        "show-close": true,
        onSubmit: _cache[7] || (_cache[7] = (val) => _ctx.findDeliveryType()),
        onClose: _cache[8] || (_cache[8] = (val) => _ctx.findDeliveryType(null))
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_StatusFilter, {
        onSubmit: _cache[9] || (_cache[9] = (val) => _ctx.findStatus(val))
      })
    ]),
    _createVNode(_component_Menu, {
      as: "div",
      class: "relative inline-block xl:hidden"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_MenuButton, { class: "flex" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-100 ease-out",
          "enter-from-class": "transform scale-95 opacity-0",
          "enter-to-class": "transform scale-100 opacity-100",
          "leave-active-class": "transition duration-75 ease-in",
          "leave-from-class": "transform scale-100 opacity-100",
          "leave-to-class": "transform scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MenuItems, { class: "absolute right-0 top-8 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none py-2 z-50" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedStoreFilter,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedStoreFilter) = $event)),
                    "return-by": "'Name'",
                    items: _ctx.joinedByStoreId,
                    "track-by": "Name",
                    "filter-by": "Name",
                    "show-by": "Name",
                    placeholder: "Store",
                    "show-close": true,
                    onSubmit: _cache[11] || (_cache[11] = (val) => _ctx.findStore()),
                    onClose: _cache[12] || (_cache[12] = (val) => _ctx.findStore(null))
                  }, null, 8, ["modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedCustomerFilter,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedCustomerFilter) = $event)),
                    "return-by": "'Name'",
                    items: _ctx.joinedByCustomerId,
                    "track-by": "Name",
                    "filter-by": "Name",
                    "show-by": "Name",
                    placeholder: "Customer",
                    "show-close": true,
                    onSubmit: _cache[14] || (_cache[14] = (val) => _ctx.findCustomer()),
                    onClose: _cache[15] || (_cache[15] = (val) => _ctx.findCustomer(null))
                  }, null, 8, ["modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_AutoComplete, {
                    modelValue: _ctx.selectedDeliveryTypeFilter,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedDeliveryTypeFilter) = $event)),
                    items: _ctx.joinedByDeliveryType,
                    placeholder: "Type",
                    "show-close": true,
                    onSubmit: _cache[17] || (_cache[17] = (val) => _ctx.findDeliveryType()),
                    onClose: _cache[18] || (_cache[18] = (val) => _ctx.findDeliveryType(null))
                  }, null, 8, ["modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_StatusFilter, {
                    onSubmit: _cache[19] || (_cache[19] = (val) => _ctx.findStatus(val))
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}